export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0B0B0B]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <img src="/logo.png" alt="Purpose Haul Dispatch" className="h-12 w-auto invert" />
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mt-4">
            Driven With Purpose.
          </p>
        </div>
        <div className="flex gap-14 font-mono text-[11px] uppercase tracking-[0.25em]">
          <div className="flex flex-col gap-3">
            <span className="text-neutral-600">Site</span>
            <a href="#about" data-testid="footer-about-link" className="text-neutral-400 hover:text-white transition-colors duration-300">About</a>
            <a href="#services" data-testid="footer-services-link" className="text-neutral-400 hover:text-white transition-colors duration-300">Services</a>
            <a href="#pricing" data-testid="footer-pricing-link" className="text-neutral-400 hover:text-white transition-colors duration-300">Pricing</a>
          </div>
          <div className="flex flex-col gap-3">
            <span className="text-neutral-600">Carriers</span>
            <a href="#contact" data-testid="footer-apply-link" className="text-neutral-400 hover:text-white transition-colors duration-300">Apply</a>
            <a href="/admin/login" data-testid="footer-admin-link" className="text-neutral-400 hover:text-white transition-colors duration-300">Admin</a>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-6">
        <p className="text-neutral-600 text-xs">
          © {new Date().getFullYear()} Purpose Haul Dispatch. All Rights Reserved.
        </p>
        <p className="text-neutral-700 text-xs max-w-xl leading-relaxed" data-testid="footer-disclaimer">
          Purpose Haul provides dispatch and administrative support to motor carriers under applicable
          agreements. Purpose Haul does not guarantee load availability, freight rates, revenue, or profitability.
        </p>
      </div>
    </div>
  </footer>
);
